/* Custom Theme JS */

function rf_get_cookie( name ) {
	var match = document.cookie.match( new RegExp( '(^| )' + name + '=([^;]+)' ) );
	if ( match ) {
		return match[2];
	} else {
		return false;
	}
}

function rf_set_cookie( key, value ) {
	var expires = new Date();
	expires.setTime(expires.getTime() + 7890000000); // 3 months
	document.cookie = key + '=' + value + ';SameSite=None;Secure;expires=' + expires.toUTCString() + ';path=/';
}

// function triggered when window is loaded
function rf_custom_init() {
  if ( document.body.classList.contains('template-product') ) {
    const productJson = JSON.parse(document.querySelector('.product-single__box__block--variant_picker [type="application/json"]').textContent);
    if ( ! productJson.length > 0) return;
  
    var productVariant = 0;
    var firstTimeChange = true;
    const thumbnailList = document.querySelector('.media-gallery .media-gallery__thumbs .thumbnail-list');
  
    // contantly check to see if current image has been changed (easier then to handle all events)
    setInterval(() => {
      const currentImage = thumbnailList.querySelector('.thumbnail-list__item--active button[aria-current] img');
      const currentImageURL = new URL( currentImage.src );
      const currentImageVariant = currentImageURL.searchParams.get('v');
      if ( productVariant != currentImageVariant ) {
        productVariant = currentImageVariant;
        if ( ! firstTimeChange ) {
          rf_custom_select_variant(productVariant, productJson);
        } else {
          firstTimeChange = false;
        }
      }
    }, 80);
  
    // handle changes of variant inputs (to avoid double switching)
    const inputs = document.querySelectorAll('.product-single__box__block--variant_picker input[type="radio"]');
    inputs.forEach((input) => {
      input.addEventListener('click', (e) => {
        setTimeout(() => {
          const imageURL = new URL( document.querySelector('.js-product-slider-single .slick-current img').src );
          const currentImageVariant = imageURL.searchParams.get('v');
          if ( productVariant != currentImageVariant ) {
            productVariant = currentImageVariant;
          }
        }, 50);
      });
    });
  }

  // use AJAX to get a suggested language (async IP to country suggestion for better initial page load).
  var suggest_lang    = document.querySelector( ".country-language-selector .suggestion-tooltip" );
  var suggest_dismiss = rf_get_cookie( "country-language-dismiss" );
  if ( suggest_lang && ! suggest_dismiss ) {
    fetch( suggest_lang.getAttribute( "data-api" ) ).then(function(response) {
        if ( ! response.ok) {
            throw new Error(response.status + " " + response.statusText);
        }
        return response.json();
    }).then(function(json) {
        if ( true === json.display ) {
          document.body.classList.add( "country-language-suggest-new" );
        }
    }).catch(function(error) {
        console.log(error);
    }).finally(function() {
    });
  }

  // Hide dropdown when clicking an item and highlight the item
  document.querySelectorAll( ".country-language-selector .dropdown-list a" ).forEach( function( item ) {
    item.addEventListener( "click", function( e ) {
      if ( e.ctrlKey ) return;

      rf_set_cookie( "country-language-dismiss", "yes" );

      if ( ! this.classList.contains( "is-active" ) ) {
        if ( this.getAttribute( "data-code" ) ) {
          var parent = e.target.closest( '.country-language-selector' );
          var form_input_code = parent.querySelector( 'input[name="country_code"]' );
          form_input_code.value = this.getAttribute( "data-code" );
          parent.requestSubmit();
        } else {
          // do any redirect
          var new_url = this.getAttribute( "href" );
          setTimeout( function(){
            window.location.href = new_url;
          }, 200 );
        }
      }
      document.body.classList.remove( "country-language-suggest-new" );
      var dropdown = this.closest( '.country-language-selector' );
      dropdown.classList.remove( "is-open" );
      dropdown.classList.add( "force-hidden" );
      setTimeout( function(){
        dropdown.classList.remove( "force-hidden" );
      }, 500 );

      e.stopPropagation();
      e.preventDefault();
    } );
  } );

  // Toggle visibility of dropdown if touched outside.
  document.addEventListener( "click", function( e ) {
    if ( ! e.target.closest( '.country-language-selector' ) ) {
      var opened_dropdown = document.querySelector( ".country-language-selector.is-open" );
      if ( opened_dropdown ) {
        opened_dropdown.classList.remove( "is-open" );
        document.body.classList.remove( "country-language-suggest-new" );
        rf_set_cookie( "country-language-dismiss", "yes" );
      }
    }
  } );

  // Handle language links click event.
  document.querySelectorAll( ".country-language-selector .country-selector-link" ).forEach( function( link ) {
    link.addEventListener( "click", function( e ) {
      var parent = e.target.closest( '.country-language-selector' );
      var opened = parent.classList.contains( "is-open" );
      document.querySelectorAll( ".country-language-selector" ).forEach((el) => {
        el.classList.remove( "is-open" );
      });
      if ( ! opened ) {
        parent.classList.add( "is-open" )
      }
      if ( document.body.classList.contains( "country-language-suggest-new" ) ) {
        document.body.classList.remove( "country-language-suggest-new" );
        rf_set_cookie( "country-language-dismiss", "yes" );
      }
      e.stopPropagation();
      e.preventDefault();
    } );
  } );
}

// select a specific variant
function rf_custom_select_variant(variant, productJson) {
  productJson.forEach((product) => {
    if (product.featured_image.src.includes(variant)) {
      product.options.forEach((option) => {
        const optionInput = document.querySelector('.product-single__box__block--variant_picker input[value="' + option + '"]');
        setTimeout(() => {
          optionInput.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        }, 50);
      });
      return;
    }
  });
}

window.addEventListener('load', rf_custom_init );
// if (document.readyState !== 'loading') {
//   rf_custom_init();
// } else {
//   document.addEventListener( 'DOMContentLoaded', rf_custom_init );
// }
